import { permissionProfiles } from 'components/Authorize/permissionProfiles';

export const NoteEntityTypes = {
    VEHICLE: 1,
    VEHICLE_DETAIL: 2,
    ACTIVITY: 3,
    MECHANICAL_WORK: 4,
    VEHICLE_IMAGE: 5,
    LOT: 6,
    TRANSPORT: 7,
    WORKORDER_ATTACHMENT: 8,
    ISSUE_TRACKER: 9,
    ISSUE_TRACKER_STATUS: 10,
    RESERVATION: 11,
    TRANSPORTINVOICES: 12,
    STORAGEINVOICES: 13,
    VENDORINVOICES: 14
}

export const NoteSource = {
    FIELD: 1,
    INTERNAL: 2, // was Office — internal-office notes carry this value
    SYSTEM: 3,
    CLIENT: 4,
    VENDOR: 5,
}

export const HOT_NOTE_FILTER_KEY = 'hot';

export const NOTE_FILTERS = [
    { key: 'field', label: 'Field Notes', match: (n) => (n.source ?? NoteSource.INTERNAL) === NoteSource.FIELD, permission: permissionProfiles.NOTES.VIEW_INTERNAL_TIER_NOTES },
    { key: 'office', label: 'Office Notes', match: (n) => !n.isHotNote && [NoteSource.INTERNAL, NoteSource.CLIENT].includes(n.source ?? NoteSource.INTERNAL), permission: permissionProfiles.NOTES.VIEW_INTERNAL_TIER_NOTES },
    { key: 'vendor', label: 'Vendor Notes', match: (n) => n.source === NoteSource.VENDOR, permission: permissionProfiles.NOTES.VIEW_VENDOR_NOTES },
    { key: 'system', label: 'System Notes', match: (n) => n.source === NoteSource.SYSTEM, permission: permissionProfiles.NOTES.VIEW_SYSTEM_NOTES },
    { key: HOT_NOTE_FILTER_KEY, label: 'Hot Note', match: (n) => !!n.isHotNote, activityOnly: true, permission: permissionProfiles.NOTES.VIEW_INTERNAL_TIER_NOTES },
]
